import * as t from "io-ts";

/**
 * Properties data real type is something like:
 * content: {...}
 * design: {...}
 * settings: {...}
 * meta: { friendlyName: string, preset: string }
 */
export const PropertiesDataV =
  t.any; /* any is wrong, we are just doing it to shut typescript up temporarily */
export type PropertiesData = t.TypeOf<typeof PropertiesDataV>;

export const TreeNodeDataV = t.type({
  type: t.string,
  properties: PropertiesDataV
});

export type TreeNodeData = t.TypeOf<typeof TreeNodeDataV>;

export const TreeNodeV: t.Type<TreeNode> = t.recursion("TreeNode", () =>
  t.intersection([
    t.type({
      id: t.number,
      data: TreeNodeDataV,
      children: t.array(TreeNodeV)
    }),
    t.partial({
      _parentId: t.number
    })
  ])
);

export type TreeNode = {
  id: number /* make readonly / t.readonly */;
  data: TreeNodeData;
  children: Array<TreeNode>; // can i make this readonly so only the helper functions in this file can add to it?
  _parentId?: TreeNode["id"];
};

export const PartialTreeV = t.type({
  root: TreeNodeV,
  _nextNodeId: t.number
  /* dont lie to typescript and say [key: string] is always a TreeNode, cuz it's not. */
});

export const TreeV = t.intersection([
  PartialTreeV,
  t.type({
    status: t.literal("valid"),
    _lookupTable: t.record(t.string, t.union([t.undefined, TreeNodeV]))
  })
]);

export const ExportedTreeV = t.intersection([
  PartialTreeV,
  t.type({ status: t.literal("exported") })
]);

export const MaybeExportedTreeV = t.union([ExportedTreeV, t.literal(false)]);

export type Tree = t.TypeOf<typeof TreeV>;
export type ExportedTree = t.TypeOf<typeof ExportedTreeV>;
export type MaybeExportedTree = t.TypeOf<typeof MaybeExportedTreeV>;
